import React from 'react';
import {IconProps} from './IconProps';

export default function ErrorCircleIcon(props: IconProps) {
  const {width = 20, height = 20, color = '#a5a5a5'} = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Status/Error"
          transform="translate(-2.000000, -2.000000)"
          fill={color}
        >
          <g id="Status-Error" transform="translate(2.000000, 2.000000)">
            <path
              d="M10,2 C5.589,2 2,5.589 2,10 C2,14.411 5.589,18 10,18 C14.411,18 18,14.411 18,10 C18,5.589 14.411,2 10,2 M10,20 C4.486,20 0,15.515 0,10 C0,4.486 4.486,0 10,0 C15.514,0 20,4.486 20,10 C20,15.515 15.514,20 10,20"
              id="Fill-2102"
            />
            <polygon id="Fill-2103" points="11 11 9 11 9 4 11 4" />
            <path
              d="M11.25,14 C11.25,14.69 10.69,15.25 10,15.25 C9.31,15.25 8.75,14.69 8.75,14 C8.75,13.31 9.31,12.75 10,12.75 C10.69,12.75 11.25,13.31 11.25,14"
              id="Fill-2104"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
